const BVContainerSelector = '#BVReviewsContainer';
const BVQAContainerSelector = '#BVQuestionsContainer';

/* istanbul ignore next */
export const scrollToSubmissionForm = (submissionContainerSelector) => {
    if (
        typeof submissionContainerSelector === 'string' &&
        document.querySelector(submissionContainerSelector)
    ) {
        document
            .querySelector(submissionContainerSelector)
            .scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    return false;
};

/* istanbul ignore next */
export const removeSubmissionForm = (submissionContainerSelector) => {
    if (
        typeof submissionContainerSelector === 'string' &&
        document.querySelector(submissionContainerSelector)
    ) {
        document.querySelector(submissionContainerSelector).innerHTML = '';
    }
    return false;
};

/**
 * Function that removes and scroll to submission form
 * @param {Object} json     JSON object sent by bv api.
 *
 */
/* istanbul ignore next */
export const removeAndScrollSubmissionForm = (json) => {
    if (json.eType === 'Write' && json.formAction === 'Cancel') {
        switch (json.eventTarget) {
            case 'Review':
                removeSubmissionForm('#BVSubmissionContainer');
                scrollToSubmissionForm('#BVReviewsContainer');
                break;
            case 'Question':
                removeSubmissionForm('#BVQASubmissionContainer');
                scrollToSubmissionForm('#BVQuestionsContainer');
                break;
            default:
                return false;
        }
    } else if (json.eType === 'Write' && json.formAction === 'Preview') {
        switch (json.eventTarget) {
            case 'Review':
                scrollToSubmissionForm('#BVSubmissionContainer');
                break;
            case 'Question':
                scrollToSubmissionForm('#BVQASubmissionContainer');
                break;
            default:
                return false;
        }
    } else if (json.eName === 'Paginate') {
        switch (json.eventTarget) {
            case 'Review':
                scrollToSubmissionForm(BVContainerSelector);
                break;
            case 'Question':
                setTimeout(scrollToSubmissionForm.bind(null, BVQAContainerSelector), 200);
                break;
            default:
                return false;
        }
    }
    return false;
};

/**
 * Function that scroll page to top of review when pagination
 * is clicked on BV reviews section.
 * @param {Object} json     JSON object sent by bv api.
 *
 */

/**
 * Function that scroll page to top of Quesion and Answer when pagination
 * is clicked on BV QA section.
 * @param {Object} json     JSON object sent by bv api.
 *
 */

/* istanbul ignore next */
export const expandReviews = (deviceType) => {
    const pdElement = document.getElementById('pdSectionId');
    const rsElement = document.getElementById('reviewSectionId');
    if (rsElement) {
        if (pdElement) {
            pdElement.scrollIntoView();
        }
        if (deviceType.isMobile || deviceType.isTablet) {
            rsElement.click();
        }
        rsElement.scrollIntoView();
    }
};

/* istanbul ignore next */
export const expandQASection = (deviceType) => {
    const pdElement = document.getElementById('pdSectionId');
    const QAAccordionRef = document.getElementById('QASectionId');
    if (QAAccordionRef) {
        if (pdElement) {
            pdElement.scrollIntoView();
        }

        if (deviceType.isMobile || deviceType.isTablet) {
            QAAccordionRef.click();
        }
        QAAccordionRef.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
};
